import { createAPI } from '@common'
export default {
  // 新建政情人物
  postLeader: (config) => createAPI('customEncryptApiName-1/0w20mfbefs', 'post', config),
  // 删除政情人物
  deleteLeader: (config) => createAPI('customEncryptApiName-1/0w20mfbefs', 'delete', config),
  // 读政情人物
  getLeader: (config) => createAPI('customEncryptApiName-1/0w20mfbefs', 'get', config),
  // 移动人物
  postLeaderMove: (config) => createAPI('customEncryptApiName-1/0w20mfbefs0npwf', 'post', config)
}
